/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_104Inputs */

const vi_carrier_status_104 = /** @type {(inputs: Carrier_Status_104Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã điều phối bưu tá lấy hàng`)
};

/**

* @param {Carrier_Status_104Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_104 = /** @type {((inputs?: Carrier_Status_104Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_104Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_104(inputs)
});